import { render, staticRenderFns } from "./Alcohol.vue?vue&type=template&id=0264a6ea&scoped=true&"
import script from "./Alcohol.vue?vue&type=script&lang=js&"
export * from "./Alcohol.vue?vue&type=script&lang=js&"
import style0 from "./Alcohol.vue?vue&type=style&index=0&id=0264a6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264a6ea",
  null
  
)

export default component.exports